<template>
  <div class="app-modal__box">
    <div class="app-modal__header">
      <h3 class="app-title" :class="`app-sitesfooter__link ${rsCollection?.config?.theme} app-title`">
        {{ $translate('Metadata', language, rsCollection.locales) }}
      </h3>
    </div>
    <div class="app-modal__body">
      <div v-for="(temp, index) in metadata.children" :key="index" class="mb-4">
        <div class="bg-gray-100 p-4">
          <div class="text-gray-800">
             {{ $translate(temp.attributes.key, language, rsCollection.locales) }} : {{ temp.attributes.value }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'pinia'
import { useSiteStore } from '~/stores/sites'
export default {
  props: {
    metadata: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      txt: {
        label: 'TXT',
        data: null,
        filename: `${this.title}.txt`,
      },
      title: '',
    }
  },
  computed: {
    ...mapState(useSiteStore, ['language', 'rsCollection']),
  },
  async mounted() {},
  methods: {},
}
</script>
